import { StringSchema, string } from 'yup'

const schema: StringSchema<TExperimentSegment> = string<TExperimentSegment>()
    .matches(/^[A-Z]$/)
    .required()

export default schema
